export default "__VITE_ASSET__CFcQ3MEP__"